var _a;
import EmailInviteModal from "./modalContents/invite-users";
import ShareTripModal from "./modalContents/share-trip";
import DraftsModal from "./modalContents/draft-list";
import { ModalKeys } from "./modalKeys";
export var modalRegistry = (_a = {},
    _a[ModalKeys.SHARE_TRIP] = {
        component: ShareTripModal,
        defaultOptions: {
            title: "Share This Trip",
            closeButtonRequired: true,
            size: "sm",
        },
    },
    _a[ModalKeys.INVITE_USERS] = {
        component: EmailInviteModal,
        defaultOptions: {
            title: "Invite Friends",
            closeButtonRequired: true,
            size: "sm",
        },
    },
    _a[ModalKeys.DRAFTS] = {
        component: DraftsModal,
        defaultOptions: {
            title: "Saved Drafts",
            closeButtonRequired: true,
            size: "md",
        },
    },
    _a);
